/* Card "View back / View front" toggle — see snippets/card-side-toggle.liquid.
   Pairs the i-th front with the i-th back by media alt order; IDs compared with Number().
   State follows the card's active Swiper slide (watched via its classes, so arrows,
   swipes, colour swatches and Swiper re-inits all stay in sync). Scoped to
   [data-card-side-toggle]. */
(function () {
  if (window.cardSideToggleInit) return
  window.cardSideToggleInit = true

  var parseIds = function (value) {
    return (value || '').split(',').filter(Boolean).map(Number)
  }

  var getMediaList = function (btn) {
    var card = btn.closest('.product-card')
    return card ? card.querySelector('.global-variant-js-media-list') : null
  }

  // data-media-id is "<section id>-<media id>"
  var slideMediaId = function (slide) {
    var raw = slide && slide.dataset.mediaId
    if (!raw) return NaN
    return Number(raw.slice(raw.lastIndexOf('-') + 1))
  }

  // Which side the active slide shows, and the media ID of its pair.
  // null when the slide is neither front nor back, or has no pair.
  var activeSide = function (btn, list) {
    var swiper = list.swiper
    var id = slideMediaId(swiper.slides[swiper.activeIndex])
    var fronts = parseIds(btn.dataset.frontIds)
    var backs = parseIds(btn.dataset.backIds)
    var i = fronts.indexOf(id)
    if (i !== -1) return backs[i] !== undefined ? { back: false, target: backs[i] } : null
    i = backs.indexOf(id)
    if (i !== -1) return fronts[i] !== undefined ? { back: true, target: fronts[i] } : null
    return null
  }

  var sync = function (btn) {
    var list = getMediaList(btn)
    var side = list && list.swiper ? activeSide(btn, list) : null
    if (!side) {
      btn.hidden = true
      return
    }
    btn.hidden = false
    btn.setAttribute('aria-label', side.back ? 'View front' : 'View back')
  }

  var bind = function (btn) {
    if (btn._cardSideBound) return
    var list = getMediaList(btn)
    if (!list || !list.swiper) return // Swiper not started yet; retried on the next DOM change
    btn._cardSideBound = true
    new MutationObserver(function () { sync(btn) })
      .observe(list, { attributes: true, attributeFilter: ['class'], subtree: true })
    sync(btn)
  }

  var bindAll = function () {
    document.querySelectorAll('[data-card-side-toggle]').forEach(bind)
  }

  // Capture phase so nothing else on the card (links, quick view) sees the click
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-card-side-toggle]')
    if (!btn) return
    event.preventDefault()
    event.stopPropagation()
    var list = getMediaList(btn)
    if (!list || !list.swiper) return
    var side = activeSide(btn, list)
    if (!side) return
    var slides = list.swiper.slides
    for (var i = 0; i < slides.length; i++) {
      if (slideMediaId(slides[i]) === side.target) {
        list.swiper.slideTo(i, 0)
        break
      }
    }
    sync(btn)
  }, true)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll)
  } else {
    bindAll()
  }

  // Cards added later (recommendations, section reloads) get their Swiper from the
  // code that inserts them, so re-scan after DOM changes (batched; setTimeout rather
  // than requestAnimationFrame, which doesn't run in background tabs)
  var pending = false
  new MutationObserver(function () {
    if (pending) return
    pending = true
    setTimeout(function () {
      pending = false
      bindAll()
    }, 50)
  }).observe(document.body, { childList: true, subtree: true })
})()
